import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const ZipExtractorAndroid: React.FC = () => (
  <SEOLandingPage
    title="Zip Extractor for Android — Unzip ZIP, RAR & 7Z Files Free | Cosmovex"
    metaDescription="Free zip extractor for Android. Open and extract ZIP, RAR, 7Z, TAR and GZ archives, preview files inside archives before extracting, and create new ZIP files. No subscriptions, no full-storage-access demands."
    ogTitle="Zip Extractor for Android — Unzip ZIP, RAR & 7Z on Your Phone"
    h1="Zip Extractor for Android: Unzip ZIP, RAR & 7Z"
    intro="Someone sent you a .zip — now what? Zip Extractor opens ZIP, RAR, 7Z, TAR and GZ archives on your Android phone, lets you peek inside before extracting, and creates new ZIPs when you need to send a bundle of files. No subscription, ever."
    paragraphs={[
      "Archives shouldn't be a puzzle on mobile. Tap any compressed file — from WhatsApp, Gmail, your downloads folder, or a file manager — and Zip Extractor opens it like a folder. Browse what's inside, extract everything to a location you choose, or pull out just the one file you actually need.",
      "The preview is the difference. Most archive apps make you extract first and look second. Here you can preview images, text, and code files inside the archive before anything touches your storage — so a 500MB archive doesn't have to be unpacked to find one document. Code files even get syntax highlighting.",
      "Creating archives is built in too. Select files or folders, tap compress, and share the resulting ZIP straight into email or chat. Password-protected archives are supported for extraction, and the app handles the formats people actually receive: ZIP, RAR, 7Z, TAR, GZ and more.",
      "It also respects your phone. No demand for blanket access to all your files — you pick what the app can see using Android's own folder picker. No subscription, no pop-up ads when you tap a file, no account. Just a clean, dark, modern interface that gets you from 'archive received' to 'files in hand' in seconds.",
    ]}
    features={[
      "Extract ZIP, RAR, 7Z, TAR, GZ and more",
      "Preview files inside archives before extracting",
      "Syntax-highlighted preview for code and text files",
      "Extract everything or just the files you pick",
      "Create ZIP archives and share them anywhere",
      "Open archives straight from email, chat or downloads",
      "Password-protected archive support",
      "Scoped storage friendly — no full-file-access demands",
      "No subscriptions, no account, free to download",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.zipvedit"
    icon="/images/play/zipvedit.png"
    appName="Zip Extractor — Unzip RAR 7Z"
    accentColor="#A8720E"
    canonicalPath="/zip-extractor-android"
  />
);

export default ZipExtractorAndroid;
